export default __webpack_public_path__ + "static/media/ru.c89ed68a.svg";